import { defineStore } from 'pinia';

export type ToastType = 'info' | 'success' | 'warning' | 'error';

interface ToastData {
  id: number;
  title?: string;
  body?: string;
  type: ToastType;
}

type ToastPayload = {
  title?: string;
  body?: string;
  timeout?: number;
};

const defaultTimeout = 3000;

const createToast = (
  type: ToastType,
  title?: string,
  body?: string
): ToastData => ({
  title,
  body,
  type,
  id: Math.random() * 1000
});

export const useToasterStore = defineStore('toasterStore', {
  state: () => ({
    toasts: [] as ToastData[]
  }),
  actions: {
    updateState(payload: ToastPayload, type: ToastType) {
      const { title, body, timeout } = payload;

      if (!title && !body) {
        console.error(`Cannot add a toast without a title or body.`);
        return;
      }

      const toast = createToast(type, title, body);
      this.toasts.push(toast);
      setTimeout(() => {
        this.toasts = this.toasts.filter((t) => t.id !== toast.id);
      }, timeout ?? defaultTimeout);
    },
    info(payload: ToastPayload) {
      this.updateState(payload, 'info');
    },
    success(payload: ToastPayload) {
      this.updateState(payload, 'success');
    },
    warning(payload: ToastPayload) {
      this.updateState(payload, 'warning');
    },
    error(payload: ToastPayload) {
      this.updateState(payload, 'error');
    },
    removeToast(id: number) {
      this.toasts = this.toasts.filter((t) => t.id !== id);
    }
  }
});
